import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    liquidations: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    liquidations(state) {
      return state.liquidations;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.liquidations = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LIQUIDATIONS(state, payload) {
      state.liquidations = payload;
    },
    ADD_LIQUIDATION(state, liquidation) {
      state.liquidations.push(liquidation);
    },
    ADD_LIQUIDATION_LINE(state, liquidationLine) {
      const foundLiquidationIndex = state.liquidations.findIndex(
        (liquidation) => liquidation.uuid === liquidationLine.liquidation?.uuid
      );
      if (foundLiquidationIndex === -1) return;

      const updatedLiquidation = state.liquidations[foundLiquidationIndex];
      if (!updatedLiquidation) return;

      if (updatedLiquidation.liquidationLines?.length) {
        updatedLiquidation.liquidationLines.push(liquidationLine);
      } else {
        updatedLiquidation.liquidationLines = [liquidationLine];
      }

      state.liquidations.splice(foundLiquidationIndex, 1, updatedLiquidation);
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchLiquidations({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .get(`/owner_liquidations`)
          .then((response) => {
            commit("SET_LIQUIDATIONS", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // TODO: log the error with Sentry
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
    addLiquidation({ commit }, liquidation) {
      return new Promise((resolve, reject) => {
        axios
          .post("/liquidations", liquidation)
          .then((response) => {
            if (response.status === 201) {
              commit("ADD_LIQUIDATION", response.data);
              resolve(response);
            } else {
              reject(new Error("Problem while adding the liquidation."));
            }
          })
          .catch((error) => {
            reject(error);
            // TODO: Log error in Sentry
          });
      });
    },
  },
};
